export interface OrdersCount {
    id: string;
    stateName: string;
    stateColor: string;
    sortOrder: number;
    orderCount: number;
}
export interface AssignedOrdersCount {
    stateName: string;         
    assignedTo: string | null; 
    orderCount: number;       
    sortOrder: number;
    stateColor: string;
};
export interface Customer {
  id?: string;
  name: string;
  email?: string;
  phone?: string;
  webDomain?: string;
  payType?: string;
  activity?: string;
  notes?: string;
  accountingCustomerNumber?: string;
    language?: string;
    satisfactionSurveyUseDefaultSettings?: boolean;
    satisfactionSurveySendingDays?: number | null;
    satisfactionSurveySendOnlineReview?: boolean | null;
    taxInvoiceDueDays?: number | null;
    serviceInvoiceDueDays?: number | null;
    assignedToUserId?: string | null;
}

export type InvoiceKind = "Tax" | "Services" | "Other";

export interface Invoice {
    id: string;
    accountingId: string | null;
    amount: number | null;
    isPaid: boolean | null;
    invoiceType: string | null;
    invoiceDate: Date | null;
    accountingCustomerNumber: string | null;
    accountingInvoiceNumber: string | null;
    accountingUpdatedDate: Date | null;
    kind: InvoiceKind | null;
    orderDetailsTaxAssessmentId: string | null;
}

export interface OrderDetailsTaxAssessment {
    id: string;
    orderId: string,
    orderDetailId: string | null;
    taxAmount: number;
    attachmentId: string | null;
    invoiced: boolean | null;
    invoiceNumber: string | null;
    paid: boolean | null;
    taxRows?: TaxRow[] | null;

    isValidated: boolean | null;
    draftCreated: boolean | null;
    draftValidated: boolean | null;
    sevDeskInvoiceId: string | null;
    sevDeskInvoiceUrl: string | null;
   
}

export interface TaxRow {
    id: string;
    taxAssessmentId: string;
    taxTypeMappingId: string | null;
    taxType: string;
    accountingKey?: string | null;
    amount: number | string;
    paymentType?: string | null;
    deferralHolder?: string | null;
    deferralAccount?: string | null;
    entryType?: string | null;
    dueDate?: string | null;
}

export interface AccountingTranslation {
    id?: string;
    sourceType: string;
    sourceValue: string;
    accountingName: string;
    accountingCode?: string;
    externalSystem?: string;
}

export interface Contact {
  id?: string;
  firstName: string;
  lastName: string;
  email: string;
  mobile: string;
  phone: string;
  customerId?: string;
  title: string ;
  emailKey: string;
  sendSatisfactionSurvey?: boolean;
}


export interface OrderInvoice {
    orderId: string;
    orderDetailId?: string | null;
    invoiceId: string;
    invoice: Invoice;
}
export interface Order {
    id: string;
    customerId: string;
    declarantCustomerId: string | null;
    internalNumber?: string | null;
    assignedToUserId: string | null;
    stateId: string | null;
    priority: string | null;
    orderTypeId: string | null;
    mergedToOrderId: string | null;
    hasUnreadEmails: boolean | null;
    unreadEmailsNumber: number | null;
    lastEmailReceivedAt : Date | null;
    dueDate: {
        year: number;
        month: number;
        day: number;
        dayOfWeek: number;
    } | null;
    //dueDate: Date | null;
    prePaid: boolean | null;
    invoiced: boolean | null;
    invoiceNumber: string | null;
    paid: boolean | null;
    initialEmailSubject: string | null;
    initialEmailSubjectShorten: string | null;
    notes: string | null;
    missingInfo: string | null;
    createdDateTime: Date;
    documentStored: boolean;
    emailConversations: string[] | null;
    serviceIds: string[] | null;  // selected services for the order
    orderServices: OrderService[] | null;  
    orderDetails: OrderDetail[] | null;
    orderInvoices?: OrderInvoice[] | null;
    orderDetailsTaxAssessments?: OrderDetailsTaxAssessment[] | null;
}

export interface Reminder {
    id: string;
    orderId: string;
    userId: string;
    reminderDateTimeUtc: string;   // ISO string from API
    snoozedUntilUtc?: string | null;
    isDismissed: boolean;
    note?: string | null;

    // Optional: when the API includes related order
    order?: {
        id: string;
        internalNumber?: string;
        initialEmailSubject?: string;
    };
}
export interface OrderDetail {
    id: string;
    orderId: string;
    declarantCustomerId: string | null;
    stateId: string | null;
    lineNumber: number;
    customerNumber: string;
    customsReferenceNumber: string;
    containerNumber: string;
    ata: string;
    atc: string | null;
    mrn: string | null;
    positionsNumber: number;
    etaDate: {
        year: number;
        month: number;
        day: number;
        dayOfWeek: number;
    } | null;
    //etaDate: Date | null;
    etaIntervalStart: {
        hour: number;
        minute: number;
        second: number;
    } | null;
    etaIntervalEnd: {
        hour: number;
        minute: number;
        second: number;
    } | null;
    sentToCustoms: boolean;
    documentsAttached: boolean;
    notes: string;
    missingInfo: string | null;
    orderDetailsTaxAssessments: OrderDetailsTaxAssessment[] | null;
}

export interface User {
    id: string;
    userName: string;
    firstName: string | null;
    lastName: string | null;
    phoneNumber: string | null;
    email: string;
    role: string;
    emailSignature: string;
    emailSignatureKey: string;
    lockoutEnd: Date | null;
    emailProviderCategory: string | null;
}
export interface IgnoreItem {
    id: number | null;
    type: string;
    value: string;
}

export interface Service {
    id: string | null;
    name: string;
}

export interface OrderType {
    id: string | null;
    name: string;
}

export interface OrderState {
    id: string | null;
    name: string;
    sortOrder: number | null;
    colorRGB: string;
    bgColorRGB: string;
    defaultForNew: boolean;
    defaultForAssigned: boolean;
    isMerged: boolean;
    isClosed:boolean;
    allowMergeInto: boolean;
    sendNotificationToCustomer: boolean;
}

export interface DetailState {
    id: string | null;
    name: string;
    sortOrder: number | null;
    colorRGB: string;
    bgColorRGB: string;
    isClosed: boolean;
    defaultForNew: boolean;
}

export interface OrderService{
    orderId: string;
    orderDetailId?: string;
    serviceId: string;
    assignedUserId: string | null;
    isCompleted: boolean | null;
    quantity: number | null;
}

export interface Attachment {
    id?: string;
    fileName: string;
    fileUrl: string;
    EmailId?: string;
}

export enum EmailTypeList {
    Customer = "Customer",
    Internal = "Internal",
    Vendor = "Vendor",
    Customs = "Customs"
}

export interface Email {
    id: string;
    incoming: boolean | null;
    from: string;
    to: string;
    cc: string | null;
    bcc: string | null;
    subject: string | null;
    content: string | null;
    messageId: string | null;
    threadId: string | null;
    orderId: string | null;
    receivedAt?: Date | null;
    attachments?: Attachment[] | null;
    isRead: boolean | null;
    isDraft: boolean | null;
    emailType: EmailTypeList | null;
}

export interface MessageTemplate {
    id?: string;
    name: string;
    subject?: string;
    message: string;
    language?: string;
}

export type EditableOrderField =
    | "ata"
    | "customerNumber"
    | "containerNumber"
    | "positionsNumber"
    | "notes"
    | "atc"
    | "mrn";

export type EditableOrderFieldMap = {
    [K in EditableOrderField]: OrderDetail[K];
};

export interface SatisfactionSurveyResult {
    id: string;
    contactName?: string;
    score: number;   // 1..10
    comment?: string;
    submittedAt: Date;
    orderId: string;

}

export interface TaxTypeMapping {
    id?: string | null;
    customsTaxTypeCode?: string;
    customsTaxTypeName?: string;
    accountingTaxCode?: string;
    accountingTaxName?: string;
}

export const PRIORITY_ORDER: Record<string, number> = {
  Low: 1,
  Medium: 2,
  High: 3,
  Critical: 4,
};

export const ORDER_PRIORITIES: OrderPriority[] = [
    "Low",
    "Medium",
    "High",
    "Critical",
];

export type OrderPriority = "Low" | "Medium" | "High" | "Critical";

// Minimal param type compatible with v7 (no `any`, no GridApi imports)
export type ValueFormatterArg<T> = {
    id: unknown;
    field: string;
    value: T;
    api: unknown;
};

//types for pricing
// src/types/index.ts

export interface ServicePriceDto {
    id: string;
    serviceId: string;
    serviceName?: string;

    customerId?: string | null;
    customerName?: string | null;

    price: number;
    currency: string;

    validFrom: string; // ISO
    validTo?: string | null;

    isActive: boolean;
}

export interface PricingFilter {
    serviceId?: string | null;
    customerId?: string | null;
    from?: string | null;
    to?: string | null;
}
